import App from '@/App.vue'
import router from '@/router'
import '@/style.css'
import HighchartsVue from 'highcharts-vue'
import 'highcharts/modules/map'
import { createPinia } from 'pinia'

// Note: Refreshes the page when a dynamically imported module can't be downloaded.
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

const pinia = createPinia()

const app = createApp(App)

app.use(router)
app.use(pinia)
app.use(HighchartsVue)
app.mount('#app')
